import * as React from "react";
import { forwardRef } from "react";
const SvgTelephoneBusy = (props, ref) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 100 100"
    ref={ref}
    {...props}
  >
    <path d="M38.69 5a1.5 1.5 0 0 0-1.237.656l-12.17 17.375a1.5 1.5 0 0 0 2.457 1.723L39.91 7.379A1.5 1.5 0 0 0 38.69 5m9.19 11.01a1.5 1.5 0 0 0-.794.281L29.707 28.457a1.5 1.5 0 1 0 1.72 2.457l17.38-12.164a1.5 1.5 0 0 0-.926-2.74m-29.398 7.025A14.28 14.28 0 0 0 5.041 36.15a14.3 14.3 0 0 0 1.441 7.418l-.377 1.221c6.016 10.673 13.218 20.15 21.596 28.43 8.381 8.278 17.944 15.354 28.69 21.238l1.37-.363a14.28 14.28 0 0 0 10.182-.065 14.28 14.28 0 0 0 9.032-12.504c-6.692-3.266-13.764-7.76-21.157-13.263a14.28 14.28 0 0 0-7.023 9.513c-10.184-8.336-18.137-17.048-25.58-26.8a14.28 14.28 0 0 0 8.533-6.77c-4.597-5.856-9.013-12.994-13.266-21.17m36.643 5.451a1.5 1.5 0 0 0-.4.057l-20.49 5.486a1.5 1.5 0 1 0 .775 2.899l20.492-5.489a1.5 1.5 0 0 0-.377-2.953" />
  </svg>
);
const ForwardRef = forwardRef(SvgTelephoneBusy);
export default ForwardRef;
